import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from './component/Login';
import AppHeader from './component/AppHeader';
import AppFooter from './component/AppFooter';
import Register from './component/Register';
import Dashboard from './component/Dashboard';
import Share from './component/Share';
import Deposit from './component/Deposit';
import Loan from './component/Loan';
import Payment from './component/Payment';
import Guarantor from './component/Guarantor';
import ChangePassword from './component/ChangePassword';
import Message from './component/Message';
import PageNotFound from './component/PageNotFound';
import './css/App.css';
import Confirm from "./component/Confirm";
import Condition from "./component/Condition";
import Welfare from "./component/Welfare";


const AppRouter = () => (
    <Router>
        <div className="app-container">
            <AppHeader />
            <Switch>
                <Route path="/online/" exact component={Login} />
                <Route path="/online/register" exact component={Register} />
                <Route path="/online/dashboard" component={Dashboard} />
                <Route path="/online/share" component={Share} />
                <Route path="/online/deposit" component={Deposit} />
                <Route path="/online/loan" component={Loan} />
                <Route path="/online/welfare" component={Welfare} />
                <Route path="/online/payment" component={ Payment } />
                <Route path="/online/guarantor" component={Guarantor} />
                <Route path="/online/confirm" component={Confirm} />
                <Route path="/online/password" component={ChangePassword} />
                <Route path="/online/message" component={Message} />
                <Route path="/online/condition" component={Condition} />
                <Route component={PageNotFound}/>
            </Switch>
            <AppFooter />
        </div>
    </Router>
);

export default AppRouter;
